import { render, staticRenderFns } from "./IconReceiptRefundSolid.vue?vue&type=template&id=01e2222f"
import script from "./IconReceiptRefundSolid.vue?vue&type=script&lang=js"
export * from "./IconReceiptRefundSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports